export const SECTION_PRODUCT_SELECTION = 1;
export const SECTION_TEMPLATE_SELECTION = 2;
export const SECTION_PARAMETERS = 3;
export const SECTION_ADDITIONAL_NOTES = 4;
export const SECTION_CUSTOMER_INFO = 5;
export const SECTION_SUMMARY = 6;
